import { createContext, Dispatch, SetStateAction } from 'react';

export interface DashboardContextProps {
  agentsCount: number;
  setAgentsCount: Dispatch<SetStateAction<number>>;
}

const DashboardContext = createContext<DashboardContextProps>({
  agentsCount: 0,
  setAgentsCount: () => {},
});

export default DashboardContext;
